import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { baseUrl } from "../../../Utils/GlobalStaticVariable";

import { toast } from 'react-toastify';
export const getUsers = createAsyncThunk('getUsers', async (arg, {
  rejectWithValue
}) => {
  try {
    const { data } = await axios.get(`${baseUrl}users`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        }
      }
    );
    return data;
  }
  catch (error) {

    return rejectWithValue(error.response.data.message);

  }
});

export const del_apiKey = createAsyncThunk('del_apiKey', async (arg, {
  rejectWithValue
}) => {
  console.log('argument here ',arg)
  const {Id} = arg
  try {
     const { data } = await axios.post(`${baseUrl}users/delete-api-key`, {user_id: arg},   
    // const { data } = await axios.delete(`${baseUrl}users/`+arg,  
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        }
      }
    );
    console.log('here is deletd data api response',data)
    return data;
  }
  catch (error) {

    return rejectWithValue(error.response.data.message);

  }
});
export const genApikey = createAsyncThunk('genApikey', async (arg, {
  rejectWithValue
}) => {
  console.log('argument here ',arg)
  const {Id} = arg
  try {
    //  const { data } = await axios.delete(`${baseUrl}users/delete-api-key/`+arg,   
    const { data } = await axios.post(`${baseUrl}users/generate-api-key`, {user_id: arg}, 
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        }
      }
    );
    console.log('here is deletd data api response',data)
    return data;
  }
  catch (error) {

    return rejectWithValue(error.response.data.message);

  }
});


export const usersSlice = createSlice({
  name: 'Channel',
  initialState: {
    value: [],
    loading: false,
    message: "",

  },
  reducers: {

  },

  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state, action) => {
      // toast.loading('Fetching Channel');
      state.loading = true;
    });
    builder.addCase(getUsers.fulfilled, (state, action) => {
      // toast.dismiss();
      // toast.success('Fetched Channel');
      state.loading = false;
      state.value = action.payload.data;

    });
    builder.addCase(getUsers.rejected, (state, action) => {
      // toast.dismiss();
      // toast.error('Fetching Channel Failed');
      state.loading = false;
      state.message = action.payload;

    });



  },
});
// toast.promise(
//   logout, {
//   pending: 'Promise is pending',
//   success: 'Promise resolved ',
//   error: 'Promise rejected '
// }
// );


export default usersSlice;


